import pythonApiClient from './pythonBaseApi';

/**
 * Servicio para gestión de tipos de documento de identidad
 * Maneja todas las operaciones relacionadas con tipos de documento de identidad
 * Migrado a Python backend con endpoint: /api/mantenimientos/tipo-documentos-identidad
 */
export const tipoDocumentoApi = {
  /**
   * Obtiene todos los tipos de documento de identidad
   * @returns {Promise} - Respuesta de la API
   */
  getAll: () => {
    return pythonApiClient.get('/mantenimientos/tipo-documentos-identidad');
  },

  /**
   * Obtiene un tipo de documento específico por ID
   * @param {number} id - ID del tipo de documento
   * @returns {Promise} - Respuesta de la API
   */
  getById: (id) => {
    return pythonApiClient.get(`/mantenimientos/tipo-documentos-identidad/${id}`);
  },

  /**
   * Crea un nuevo tipo de documento de identidad
   * @param {Object} data - Datos del tipo de documento
   * @returns {Promise} - Respuesta de la API
   */
  create: (data) => {
    return pythonApiClient.post('/mantenimientos/tipo-documentos-identidad', data);
  },

  /**
   * Actualiza un tipo de documento existente
   * @param {number} id - ID del tipo de documento
   * @param {Object} data - Datos actualizados del tipo de documento
   * @returns {Promise} - Respuesta de la API
   */
  update: (id, data) => {
    return pythonApiClient.put(`/mantenimientos/tipo-documentos-identidad/${id}`, data);
  },

  /**
   * Elimina un tipo de documento
   * @param {number} id - ID del tipo de documento
   * @returns {Promise} - Respuesta de la API
   */
  delete: (id) => {
    return pythonApiClient.delete(`/mantenimientos/tipo-documentos-identidad/${id}`);
  }
};

export default tipoDocumentoApi;
